(ns bp-clients.tv-app.utils.tree-walker
  "Wrapper namespace for javascript node traversing utils")

(def ^:private accept (-> js/NodeFilter .-FILTER_ACCEPT))
(def ^:private reject (-> js/NodeFilter .-FILTER_REJECT))
(def ^:private skip (-> js/NodeFilter .-FILTER_SKIP))
(def ^:private show (-> js/NodeFilter .-SHOW_ELEMENT))
(def ^:private node-element (-> js/Node .-ELEMENT_NODE))
(def ^:private document-element (-> js/document .-documentElement))

(defn accept-node [_node] accept)
(defn reject-node [_node] reject)
(defn skip-node [_node] skip)
(defn node-type [node] (.-nodeType node))
(defn node-display [node] (-> node js/window.getComputedStyle .-display))
(defn node-rect [node] (-> node .getBoundingClientRect))

(defn active-element-or-document
  []
  (or (js/document.querySelector ".focused") (.-activeElement js/document) (.-documentElement js/document)))

(defn defined? [node] (-> node boolean))
(defn element? [node] (= (node-type node) node-element))
(defn visible? [node] (not= (node-display node) "none"))

(def node? (every-pred defined? element? visible?))
(defn next-node [node] (-> node .nextNode))
(defn previous-node [node] (-> node .previousNode))

(defn- safe-filter
  ([]
   (safe-filter accept-node))
  ([filter-fn]
   ;; old browsers fix
   (set! (.-acceptNode filter-fn) filter-fn)))

(defn node-filter
  [pred node]
  (if (pred node) accept skip))

(defn create-filter
  ([]
   (safe-filter (partial node-filter node?)))
  ([filter-fn]
   (safe-filter filter-fn)))

(defn create-tree-walker
  ([]
   (create-tree-walker (create-filter) show document-element))
  ([filter-fn]
   (create-tree-walker filter-fn show document-element))
  ([filter-fn what-to-show]
   (create-tree-walker filter-fn what-to-show document-element))
  ([filter-fn what-to-show root]
   (js/document.createTreeWalker root what-to-show filter-fn)))

(defn move-raw
  [filters move-fn element]
  (let [tree-walker (create-tree-walker filters)
        _ (when (node? element) (set! (.-currentNode tree-walker) element))
        result (move-fn tree-walker)]
    (or result element)))

(defn has-attribute?
  [attribute node]
  (some-> node
          (.hasAttribute attribute)))

(defn get-attribute
  [attribute node]
  (some-> node
          (.getAttribute attribute)))

(defn parseInt
  [string]
  (js/parseInt string 10))

(defn same-node
  [n1 n2]
  (some-> n1
          (.isEqualNode n2)))

(comment

  (defn get-tab-index
    [node]
    (or (some->> node
                 (get-attribute "tabindex")
                 parseInt) 0))

  (defn tab-index-is-x?
    [x node]
    (= (get-tab-index node) x))

  (def has-tab-index? (partial has-attribute? "tabindex"))
  (def tab-index-equal-10 (partial tab-index-is-x? 10))

  (def tab-filter (every-pred node? has-tab-index? tab-index-equal-10))

  (def move-left (partial  move-raw (partial node-filter tab-filter) previous-node))
  (def move-right (partial move-raw (partial node-filter tab-filter) next-node))

  (move-raw tab-filter next-node (active-element-or-document))
  (move-left (active-element-or-document))
  (move-right (active-element-or-document))

  (same-node (move-left (active-element-or-document)) (move-right (active-element-or-document))) ;false
  )
